import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_ALL_CONTRACT_FOR_PROVIDER } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/*
 * Contract types for a location, as a contract_type -> contracts_details ->
 * shift_types tree.
 *
 * `in_is_work_calendar: 1` is required: it is what makes the procedure return
 * the nested shift-type structure the cascading pickers need. The older web
 * dialog never sent it, which is why it only ever saw a flat list.
 */
export const getContractTypesForProvider = async (cookiesData, dispatch, providerId, locationMstrKey) => {
  if (!cookiesData || !providerId || !locationMstrKey) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_location_mstr_key: locationMstrKey,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
      in_is_work_calendar: 1,
    };

    const response = await POSTAPI(false, GET_ALL_CONTRACT_FOR_PROVIDER, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching contract types for provider:", error);
    return [];
  }
};
